import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Button, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useDispatch } from "react-redux"
import UIIcon from "../../components/UIIcon"
import { ContentContainer } from "./components/styles"
import AmountInput from "../../components/AmountInput"
import { setPaymentAmount } from "../../store/slices/payment"
import { ROUTES_PATHS, PROVIDER_LIMIT } from "../../utils/constants"
import { clearCustomBackHandler, setCustomBackHandler } from "../../store/slices/headerSlice"
import { useGetUserInfo } from "../../api/hooks/useGetUserInfo"

const PaymentMethodContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  marginTop: theme.spacing(2),
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
}))

const PaymentMethodInfo = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}))

export const Refill = () => {
  const [amount, setAmount] = useState<string>("")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data: userInfo } = useGetUserInfo(false)

  const limit = Math.min(userInfo?.availableRefill!, userInfo?.availableWithdraw!, PROVIDER_LIMIT)

  const handleAmountChange = (newAmount: string) => {
    setAmount(newAmount)
  }

  const handleContinue = () => {
    dispatch(setPaymentAmount(Number(amount)))
    navigate(`/${ROUTES_PATHS.topUpMbankAccountPayments}/bank`)
  }

  useEffect(() => {
    const handleBack = () => {
      navigate(`/${ROUTES_PATHS.quit}`, {
        replace: true,
      })
    }

    dispatch(setCustomBackHandler(handleBack))

    return () => {
      dispatch(clearCustomBackHandler())
    }
  }, [dispatch, navigate])

  return (
    <Box sx={ContentContainer}>
      <AmountInput
        value={amount}
        currency="₽"
        type="number"
        limit={limit}
        variant="filled"
        placeholder="Введите сумму"
        label="Сумма пополнения"
        onChange={(e) => handleAmountChange(e.target.value)}
      />

      <PaymentMethodContainer>
        <UIIcon iconName="rusBankIcon" size={46} />
        <PaymentMethodInfo>
          <Typography variant="subtitle1">Со счета в вашем банке</Typography>
          <Typography variant="body2" color="textSecondary">
            Банки РФ
          </Typography>
        </PaymentMethodInfo>
      </PaymentMethodContainer>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          variant="contained"
          disabled={amount?.length < 2}
          onClick={handleContinue}
        >
          Продолжить
        </Button>
      </Box>
    </Box>
  )
}
